import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'

import { GlgButton } from 'Shared/components'
import BaseCloningModal from './BaseCloningModal'
import { selectCloneLeaguesIndexURL } from '../../../reducers/session_saver'

const REDIRECT_DELAY_MS = 5000

const SaveDraftSuccessModal = () => {
  const indexURL = useSelector(selectCloneLeaguesIndexURL)

  useEffect(() => {
    if (!indexURL) {
      return
    }

    const timer = setTimeout(() => {
      window.location.href = indexURL
    }, REDIRECT_DELAY_MS)

    return () => clearTimeout(timer)
  }, [ indexURL ])

  const modalContent = (<>
    <span>{window.I18n.t('clone_leagues_sessions.modals.save_draft_success.content_1')}</span>
    <span>{window.I18n.t('clone_leagues_sessions.modals.save_draft_success.content_2')}</span>
  </>)

  return (<BaseCloningModal
    title={window.I18n.t('clone_leagues_sessions.modals.save_draft_success.title')}
    content={modalContent}
    rightButton={<GlgButton
      className={'cls-steps-modal__right_button'}
      text={window.I18n.t('clone_leagues_sessions.modals.save_draft_success.confirm')}
      onClick={() => { window.location.href = indexURL }}
    />}
  />)
}

export default SaveDraftSuccessModal
